<mat-toolbar class="topbar">

  <div class="d-none d-lg-flex">

  </div>

  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center" >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="d-flex d-lg-none justify-content-center" >
    <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
  </button>

  <button mat-icon-button aria-label="QuickActions" class="d-flex justify-content-center" (click)="openZBEQuickActionsBottomSheet()" *ngIf="!isTestEnv">
    <i-tabler name="recharging" style="color: #8f969d;" class="icon-24 d-flex"></i-tabler>
  </button>
  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img src="assets/images/profile/ninja-bo.png" class="rounded-circle object-cover" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <ng-scrollbar
      class="position-relative"
      style="height: 690px"
    >
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">{{ "Backoffice - Administrateur" | translate }}</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img
            src="assets/images/profile/ninja-bo.png"
            class="rounded-circle"
            width="95"
          />
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0">{{ authSessionDto.USERNAME }}</h6>
            <span class="f-s-14 d-block m-b-4">{{ ROLE_WORKSPACE_USER_LABELS[authSessionDto.ROLE_ID] }}</span>
            <div style="font-size:10px">{{ !!appVersion ? (appVersion.APP_VERSION_ID + ' | ' + appVersion.APP_VERSION_DISPLAY + (appVersion.APP_ENVIRONMENT != '' && appVersion.APP_ENVIRONMENT != 'Production' ? (' | ' + appVersion.APP_ENVIRONMENT) : '')) : '' }}</div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!isTestEnv">
        <div class="p-x-32">
          <a routerLink="/cluadmin/apps/profile" class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <img src="assets/images/svgs/icon-account.svg" width="20" />
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "Mon compte" | translate }}
                </h5>
                <span class="mat-body-1">{{ "Modifier les infos du compte" | translate }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="p-x-32">
          <a (click)="doLockAccount()" class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="lock-square-rounded" style="font-size: 30px"></i-tabler>
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "Verrouiller la session" | translate }}
                </h5>
                <span class="mat-body-1">{{ "Verrouiller la session" | translate }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="p-y-0 p-x-32 d-flex" (click)="$event.stopPropagation()">
          <!-- --------------------------------------------------------------- -->
          <!-- langugage Dropdown -->
          <!-- --------------------------------------------------------------- -->
          <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
            <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
          </button>
          <span style="font-weight: 700;margin: auto; margin-left: 0;">{{selectedLanguage.language}}</span>
          <mat-menu #flags="matMenu" class="cardWithShadow">
            <button mat-menu-item *ngFor="let lang of languages" (click)="changeLanguage(lang)" >
              <div class="d-flex align-items-center">
                <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
                <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
              </div>
            </button>
          </mat-menu>
        </div>
        <div class="p-x-32">
          <div class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="license" style="font-size: 30px"></i-tabler>
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "Licence" | translate }}
                </h5>
                <div *ngIf="appVersion?.NF525 === true" style="background: #4575c8;color: white;font-size: 12px;display: flex;justify-content: center;position: absolute;top: 1px;left: 60px;padding: 2px;border-radius: 10px;">
                  NF525
                </div>
                <span class="mat-body-1">{{ "Date Expiration" | translate }}: {{ authSessionDto.LICENCE_DATE_EXPIRATION | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-x-32">
          <a routerLink="/cluadmin/apps/release-notes" class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="clipboard-text" style="font-size: 30px"></i-tabler>
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "Release Notes" | translate }}
                </h5>
                <span class="mat-body-1">{{ "Notes de version" | translate }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="p-x-32 b-b-1">
          <a (click)="openAboutDialog()" class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="clipboard-text" style="font-size: 30px"></i-tabler>
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "A propos" | translate }}
                </h5>
                <span class="mat-body-1">Cauris Link Up</span>
              </div>
            </div>
          </a>
        </div>
        <div class="p-x-32 b-b-1">
          <a href="javascript:;" (click)="doSwitchToTestEnvironment()" class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="test-pipe-2" style="font-size: 30px"></i-tabler>
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "Environnement de test" | translate }}
                </h5>
                <span class="mat-body-1">{{ "Basculer vers Env TEST" | translate }}</span>
              </div>
            </div>
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="isTestEnv && isPreprodEnv">
        <div class="p-x-32 b-b-1">
          <a href="javascript:;" (click)="doSwitchToProdEnvironment()" class="p-y-16 text-decoration-none d-block text-hover-primary">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="cloud-data-connection" style="font-size: 30px"></i-tabler>
              </button>
              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ "Environnement de prod" | translate }}
                </h5>
                <span class="mat-body-1">{{ "Basculer vers Env PROD" | translate }}</span>
              </div>
            </div>
          </a>
        </div>
      </ng-container>
      <div class="p-y-12 p-x-32">
        <a (click)="doLogout()" mat-stroked-button color="primary" class="w-100">{{ "Se deconnecter" | translate }}</a>
      </div>
    </ng-scrollbar>
  </mat-menu>

  <ng-container *ngIf="isTauri">
    <button mat-icon-button aria-label="Réduire" matTooltip="Réduire l'application" class="d-flex justify-content-center" (click)="doMinimizeApp()">
      <i-tabler name="window-minimize" style="color: #073869;" class="icon-24 d-flex"></i-tabler>
    </button>

    <button mat-icon-button aria-label="Quitter" matTooltip="Quitter l'application" class="d-flex justify-content-center" (click)="doQuitApp()">
      <i-tabler name="square-rounded-x-filled"  style="color: #073869;" class="icon-24 d-flex"></i-tabler>
    </button>
  </ng-container>
</mat-toolbar>
